export const CONFIG = {
    TILE_WIDTH: 64,
    TILE_HEIGHT: 32,
    // Hard floor on how far out the camera may ever zoom (GameScene.ts's calcMinZoom), and the
    // basis BackgroundCanvas.ts derives its chunk-per-axis backstop from — shared so the two stay
    // traceable to each other instead of silently drifting apart as two separate literals.
    ABSOLUTE_MIN_ZOOM: 0.25,
};
